
<div mat-dialog-title>
	<span translate>batch.from.same.invoice</span>
	<b *ngIf="relatedBatchesInvoice">&nbsp;{{ relatedBatchesInvoice }}&nbsp;</b>
	<span translate>batch.from.same.invoice.available</span>
</div>
<div mat-dialog-actions>
	<button type="button" mat-raised-button (click)="evtOk()"
		class="dialog-button copo-dialog-button-margin copo-button" tabindex="-1" copoFocusMe>
		<span translate>eoffer.feasibility.yes</span>
	</button>
</div>
